import { render } from "./aboutProgram.vue?vue&type=template&id=32f63940&scoped=true"
import script from "./aboutProgram.vue?vue&type=script&lang=js"
export * from "./aboutProgram.vue?vue&type=script&lang=js"

import "./aboutProgram.vue?vue&type=style&index=0&id=32f63940&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f63940"]])

export default __exports__